import { render, staticRenderFns } from "./FavoriteItem.vue?vue&type=template&id=a08f14e4&scoped=true&"
import script from "./FavoriteItem.vue?vue&type=script&lang=js&"
export * from "./FavoriteItem.vue?vue&type=script&lang=js&"
import style0 from "./FavoriteItem.vue?vue&type=style&index=0&id=a08f14e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a08f14e4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VImg } from 'vuetify/lib/components/VImg';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
installComponents(component, {VCard,VImg,VListItemSubtitle})
